'use client';

import type { ReactNode } from 'react';
import { HStack } from '@terra/ui-styled-system';
import {
  CancelCircleIcon,
  CheckmarkCircle02Icon,
  Edit03Icon,
} from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { IconButton } from '../../../../../components/icon-button';
import { Tooltip } from '../../../../../components/tooltip';
import { HitlPendingActionButton } from './HitlPendingActionButton';

type HITLPendingHeaderActionsProps = {
  onApprove?: () => void;
  onReject?: () => void;
  onEdit?: () => void;
  onReview?: () => void;
  disabled?: boolean;
};

export function HITLPendingHeaderActions({
  onApprove,
  onReject,
  onEdit,
  onReview,
  disabled,
}: HITLPendingHeaderActionsProps): ReactNode {
  const t = useTranslations(
    'designSystem.chat.hitlRequestConfirmationPromptCard',
  );
  const tCommon = useTranslations('designSystem.common');

  if (!onApprove && !onReject && !onEdit && !onReview) {
    return undefined;
  }

  return (
    <HStack
      gap={0.5}
      alignItems="center"
      onClick={(event) => event.stopPropagation()}
    >
      {onReject ? (
        <HitlPendingActionButton
          label={tCommon('reject')}
          icon={<CancelCircleIcon size={12} />}
          onClick={onReject}
          disabled={disabled}
        />
      ) : null}
      {onApprove ? (
        <HitlPendingActionButton
          label={t('approve')}
          icon={<CheckmarkCircle02Icon size={12} />}
          onClick={onApprove}
          disabled={disabled}
        />
      ) : null}
      {onReview ? (
        <HitlPendingActionButton
          label={t('review')}
          onClick={onReview}
          disabled={disabled}
        />
      ) : onEdit ? (
        <Tooltip title={tCommon('edit')} openDelay={300}>
          <IconButton
            variant="ghost"
            size="xs"
            aria-label={tCommon('edit')}
            onClick={onEdit}
            disabled={disabled}
            _hover={{ color: 'fg.default' }}
          >
            <Edit03Icon size={14} />
          </IconButton>
        </Tooltip>
      ) : null}
    </HStack>
  );
}
